function htmlToReadableText(value) {
    if (!value) return "";

    const decoded = String(value)
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&ndash;|&mdash;/g, "-");

    return decoded
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<li[^>]*>/gi, "- ")
        .replace(/<\/li>/gi, "\n")
        .replace(/<\/(p|h[1-6]|div|ul|ol)>/gi, "\n")
        .replace(/<[^>]*>/g, "")
        .replace(/[ \t]+\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
}

function isOverviewTitleLine(line) {
    if (!line) return false;
    const cleanLine = line.trim();
    if (!cleanLine) return false;

    const exactTitles = [
        "Phân tích trước trận đấu",
        "Kèo châu Á",
        "Kèo châu Âu",
        "Kèo tài xỉu",
        "Dự đoán tỷ số",
        "AI dự đoán",
        "Kết luận",
    ];

    if (exactTitles.includes(cleanLine)) return true;

    // Matches section headings like "1) ...", "1.1. ...", "2) ..."
    if (/^\d+(\.\d+)*[\)\.]?\s+/.test(cleanLine)) return true;

    return false;
}

export function parseOverviewBlocks(value) {
    const text = htmlToReadableText(value);
    if (!text) return [];

    return text
        .split("\n")
        .map((line) => {
            const content = line.trim();
            return {
                content,
                isTitle: isOverviewTitleLine(content),
            };
        })
        .filter((item) => item.content);
}

export function normalizePick(rawValue, fallbackValue = "-") {
    if (!rawValue) return fallbackValue;
    const lines = String(rawValue)
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    const pickLine = [...lines].reverse().find((line) => /chọn\s*:/i.test(line));
    if (!pickLine) return fallbackValue;
    const pickValue = pickLine.split(/chọn\s*:/i)[1]?.trim();
    return pickValue || fallbackValue;
}

export function normalizeOverUnderPick(rawValue, fallbackValue = "-") {
    const normalized = normalizePick(rawValue, fallbackValue);
    const matchedType = normalized.match(/(Tài|Xỉu)/i);
    return matchedType?.[1] || normalized;
}

export function formatHandicap(rawHandicap) {
    if (rawHandicap === null || rawHandicap === undefined || rawHandicap === "") return "";
    const parsed = Number(rawHandicap);
    if (Number.isNaN(parsed)) return String(rawHandicap);
    if (parsed > 0) return `+${parsed}`;
    return `${parsed}`;
}

function getTeamPerspective(match, teamId) {
    if (!match) return null;
    const homeTeamId = Number(match?.homeTeamId ?? match?.homeId ?? 0);
    const awayTeamId = Number(match?.awayTeamId ?? match?.awayId ?? 0);
    const homeScore = Number(match?.scoreHome ?? match?.homeScore ?? 0);
    const awayScore = Number(match?.scoreAway ?? match?.awayScore ?? 0);

    if (teamId && Number(teamId) === homeTeamId) {
        return {
            teamScore: homeScore,
            oppScore: awayScore,
            oppName: match?.away || match?.awayTeam?.name || "đối thủ",
        };
    }

    if (teamId && Number(teamId) === awayTeamId) {
        return {
            teamScore: awayScore,
            oppScore: homeScore,
            oppName: match?.home || match?.homeTeam?.name || "đối thủ",
        };
    }

    return {
        teamScore: homeScore,
        oppScore: awayScore,
        oppName: match?.away || match?.awayTeam?.name || "đối thủ",
    };
}

export function countWins(matches, teamId) {
    if (!Array.isArray(matches)) return 0;
    return matches.reduce((total, item) => {
        const perspective = getTeamPerspective(item, teamId);
        if (!perspective) return total;
        return perspective.teamScore > perspective.oppScore ? total + 1 : total;
    }, 0);
}

export function buildFormText(matches, teamId, teamName) {
    if (!Array.isArray(matches) || matches.length === 0) {
        return `${teamName} chưa có đủ dữ liệu phong độ trong các trận gần đây.`;
    }

    const recentMatches = matches.slice(0, 10);
    const winCount = countWins(recentMatches, teamId);
    const latestMatch = recentMatches[0];
    const latestPerspective = getTeamPerspective(latestMatch, teamId);

    if (!latestPerspective) {
        return `${teamName} có phong độ ổn định với ${winCount} chiến thắng trong ${recentMatches.length} trận gần nhất.`;
    }

    const latestScore = `${latestPerspective.teamScore}-${latestPerspective.oppScore}`;
    let latestResultText = `vừa thi đấu với ${latestPerspective.oppName} ${latestScore}.`;
    if (latestPerspective.teamScore > latestPerspective.oppScore) {
        latestResultText = `vừa giành chiến thắng ${latestScore} trước ${latestPerspective.oppName}.`;
    } else if (latestPerspective.teamScore < latestPerspective.oppScore) {
        latestResultText = `vừa để thua ${latestScore} trước ${latestPerspective.oppName}.`;
    } else {
        latestResultText = `hòa trận vừa qua trước ${latestPerspective.oppName} ${latestScore}.`;
    }

    return `${teamName} có phong độ ổn định với ${winCount} chiến thắng trong ${recentMatches.length} trận gần nhất, ${latestResultText}`;
}
